<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents">
      <h1 class="l-pageTitle"><img src="@/assets/img/common/icon-nav4_blue.svg" alt="">書式</h1>
      <div class="l-docSearch">
        <label><img src="@/assets/img/common/icon-search.svg" alt="">キーワード</label>
        <div class="l-inputAccount w-short">
          <TextBox v-model="searchForm.keyword" placeholder="" name="keyword" ></TextBox>
        </div>
        <div class="btn-basic is-inlne is-primary" @click="search()"><a>検索</a></div>
      </div>

      <div class="l-contentsBox l-docBox">
        <DocTree></DocTree>
        <div class="l-docBox__main" v-show="path || isSearchMode">
          <ul class="l-docPath" v-if="!isSearchMode">
            <li v-for="(breadcrumbs, index) in breadcrumbsList" :key=index>
              <template v-if="index !== breadcrumbsList.length - 1">
                <a @click="clickBreadCrumbs(index)"><img src="@/assets/img/common/icon-folder.svg" width="14px" alt="">{{ breadcrumbs }}</a>
              </template>
              <template v-else>
                <li>{{ breadcrumbs }}</li>
              </template>
            </li>
          </ul>
          <ul class="l-docPath" v-else>
            <li><img src="@/assets/img/common/icon-search.svg" width="14px" alt="">「{{ searchKeyword }}」の検索結果（{{ searchResultCount }}件）</li>
          </ul>
          <DocList
            ref="docList"
            @emit-set-search-result-count="emitSetSearchResultCount"
          ></DocList>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import DocTree from '@/components/parts/doc/DocTree.vue';
import DocList from '@/components/parts/doc/DocList.vue';
import { saveAs } from "file-saver";

export default {
  components: {
    Loading,
    DocTree,
    TextBox,
    DocList,
  },
  data() {
    return {
      isProcessing: false,
      file: {
        url: '',
        name: '',
        id: '',
      },
      searchForm: {
        keyword: null,
      },
      searchResultCount: 0
    }
  },
  computed: {
    path() {
      return this.$store.getters['doc/getPath'];
    },
    breadcrumbsList() {
      return this.$store.getters['doc/getPathArrayForDisplay'];
    },
    isSearchMode() {
      return this.$store.getters['doc/getIsSearchMode'];
    },
    searchKeyword() {
      return this.$store.getters['doc/getSearchKeyword'];
    }
  },
  created: function() {
    this.$store.dispatch('doc/init');
  },
  methods: {
    async download() {
      this.isProcessing = true;
      await saveAs(this.file.url, this.file.name);
      this.isProcessing = false;
    },
    search() {
      this.$store.dispatch('doc/setIsSearchMode', true);
      this.$store.dispatch('doc/setSearchKeyword', this.searchForm.keyword);
      this.$refs.docList.searchDocFileList(this.searchForm.keyword, 1);
    },
    clickBreadCrumbs(index) {
      let pathArrayForDisplay = this.breadcrumbsList;
      pathArrayForDisplay.splice(index + 1);
      let path = pathArrayForDisplay.join('/');

      this.$store.dispatch('doc/setPathArrayForDisplay', pathArrayForDisplay);
      this.$store.dispatch('doc/setPath', path);
      this.$refs.docList.getDocList(path, 1);
    },
    emitSetSearchResultCount(param) {
      this.searchResultCount = param.searchResultCount;
    }
  },
}

</script>

<style>
.inner-doc-container {
  display: grid;
  /* 1列目から順番に180px、1fr、160pxの幅 */
  grid-template-columns: 300px 1fr;
  /* 1行目から順番に60px 1fr 90pxの高さ */
  grid-template-rows: 10px 1fr;
}

.inner-doc-header {
  /* 列の1本目から4本目のグリッドラインまで */
  grid-column-start: 1;
  grid-column-end: 4;
  /* 行の1本目から2本目のグリッドラインまで */
  grid-row-start: 1;
  grid-row-end: 3;
}

.inner-doc-nav {
  /* 列の1本目から2本目のグリッドラインまで */
  grid-column-start: 1;
  grid-column-end: 3;
  /* 行の2本目から3本目のグリッドラインまで */
  grid-row-start: 11;
  grid-row-end: auto;
}

.inner-doc-main {
  /* 列の2本目から3本目のグリッドラインまで */
  grid-column-start: 2;
  grid-column-end: auto;
  /* 行の2本目から3本目のグリッドラインまで */
  grid-row-start: 11;
  grid-row-end: auto;
}
</style>
